import { DISCLAIMER_TEXTS } from '../lib/disclaimer'
import { useI18n } from '../lib/i18n'

export function ChatDisclaimer() {
  const { lang } = useI18n()
  const l = lang === 'zh' ? 'zh' : 'en'
  return (
    <div className="mt-3 pt-2 border-t border-brand-100">
      <p className="text-[11px] leading-relaxed text-brand-400">
        {DISCLAIMER_TEXTS.chatDisclaimer[l]}
      </p>
    </div>
  )
}

export function AIDraftHint() {
  const { lang } = useI18n()
  const l = lang === 'zh' ? 'zh' : 'en'
  return (
    <div className="mt-4 py-2 px-3 rounded-lg bg-brand-50 border border-brand-100">
      <p className="text-xs text-brand-500 leading-relaxed">
        {DISCLAIMER_TEXTS.shortHint[l]}
      </p>
    </div>
  )
}
